module.exports = __webpack_public_path__ + "img/brand--sherfarma.720f8592.png";